import axios from "axios";

export const getChildren = async () => {
  const { data } = await axios.get("/api/parent/children");
  return data;
};

export const getChildSummary = async (studentId) => {
  const { data } = await axios.get(`/api/parent/children/${studentId}/summary`);
  return data;
};

export const getChildAttendance = async (studentId, params) => {
  const { data } = await axios.get(`/api/parent/children/${studentId}/attendance`, { params });
  return data;
};

export const getChildAssignments = async (studentId) => {
  const { data } = await axios.get(`/api/parent/children/${studentId}/assignments`);
  return data;
};

export const getChildResults = async (studentId, params) => {
  const { data } = await axios.get(`/api/parent/children/${studentId}/results`, { params });
  return data;
};

export const getChildFees = async (studentId) => {
  const { data } = await axios.get(`/api/parent/children/${studentId}/fees`);
  return data;
};

export const getChildLeaves = async (studentId) => {
  const { data } = await axios.get(`/api/parent/children/${studentId}/leaves`);
  return data;
};

export const getChildSchedule = async (gradeId) => {
  const { data } = await axios.get(`/api/schedules`, { params: { grade_id: gradeId } });
  return data;
};
